import { DataBean } from "../DataBean";

export class CustomerType extends DataBean {



    public async deleteCustomerType(idCustomerType: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "void_deleteCustomerType_Number", [idCustomerType]);
    }

    public async getCustomerTypeCatalog(regexStr: any, page: any, recordsPerPage: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_getCustomerTypeCatalog_String_Number_Number", [regexStr, page, recordsPerPage]);
    }

}